// pages/_app.tsx
import type { AppProps } from "next/app";
import { StatsigWrapper } from "@/src/components/StatsigWrapper";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// styles
import "@/src/styles/globals.scss";

const queryClient = new QueryClient();

export default function MyApp({ Component, pageProps }: AppProps) {
    return (
        <QueryClientProvider client={queryClient}>
            <StatsigWrapper>
                <Component {...pageProps} />
            </StatsigWrapper>
        </QueryClientProvider>
    );
}
